import './PageHeader.css'

function PageHeader({topic,topicSentence} ) {
  return (
    <section className='page-header-section'>
        <div className='page-header-content container'>
            <h2>{topic}</h2>
            <p>{topicSentence}</p>
        </div>
    </section>
  )
}

export default PageHeader